export function printPage(url, callback) {
    let iframe = document.createElement('iframe');
    iframe.setAttribute('src', url);
    iframe.setAttribute('height', '0');
    iframe.setAttribute('name', 'for_print');
    iframe.setAttribute('id', 'for_print');
    iframe.style.position = 'absolute';
    document.body.appendChild(iframe);

    iframe.onload = () => {
        const printFrame = window.frames['for_print'];
        printFrame.focus();
        printFrame.print();

        setTimeout(() => {
            document.body.removeChild(iframe);
            if (callback) callback();
        }, 100);
    };
}